import { ImageTextSection } from "@/types";
import { RichText } from "@/components/StrapiComponents/RichText";

import { ImageGallery } from "./ImageGallery";

export const ImageTextSectionComponent = ({ content }: { content: ImageTextSection }) => {
	return (
		<section className="section-wrapper">
			<div className="max-wrapper-content">
				<div className="grid-layout-2-2">
					{content.Layout === "Left" && <div className="grid-column gallery-wrapper --before">{content.gallery && <ImageGallery images={content.gallery.image} />}</div>}
					<div className="grid-column">{content.content && <RichText content={content.content.content} />}</div>
					{content.Layout === "Right" && <div className="grid-column gallery-wrapper --after">{content.gallery && <ImageGallery images={content.gallery.image} />}</div>}
				</div>
			</div>
		</section>
	);
};
